import { SET_HTTP_ERROR_CODE } from "../constants/httpErrors";

export default function httpErrors(state = false, action) {
  if (action.type == SET_HTTP_ERROR_CODE) {
    return { httpErrorCode: action.code };
  }
  return state;
}
